import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Inject admin key on admin endpoints
api.interceptors.request.use((config) => {
  if (config.url && config.url.startsWith("/admin")) {
    const key = localStorage.getItem("lyp_admin_key");
    if (key) config.headers["X-Admin-Key"] = key;
  }
  return config;
});

export default api;
